import actionTypes from './actionTypes';
import communityActionTypes from 'src/modules/community/shared/actionTypes';
import editProfileActionTypes from 'src/modules/user/editProfile/actionTypes';
import wsActionTypes from 'src/modules/websockets/actionTypes';
import linkUtils from 'src/utils/linkUtils';

export const initialState = {
  communityErrorStatusCode: null,
  currentCommunity: null,
  currentUser: null,
  isFloatingSignupBoxVisible: true,
  lang: 'en',
  notifications: [],
  roles: [],
  sessionId: null,
  showVerificationBar: false,
  unreadMessagesCount: 0,
  unreadNotificationsCount: 0,
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_SERVER_SESSION:
      return {
        ...state,
        sessionId: action.sessionId,
      };
    case actionTypes.UNSET_SERVER_SESSION:
      return {
        ...state,
        sessionId: null,
      };
    case actionTypes.FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...action.user,
          avatarImageUrl: linkUtils.generateAvatarLink(action.user),
        },
        showVerificationBar: !!action.user.unverifiedEmail,
        lang: action.user.locale.substring(0, 2),
      };
    case actionTypes.FETCH_CURRENT_COMMUNITY_SUCCESS: {
      const community = action.community;
      // don't overwrite guidelines if community doesn't change
      if (state.currentCommunity && state.currentCommunity.communityId === community.communityId) {
        community.guidelines = state.currentCommunity.guidelines;
      }
      return {
        ...state,
        currentCommunity: community,
      };
    }
    case actionTypes.CLEAR_CURRENT_COMMUNITY:
      return {
        ...state,
        currentCommunity: null,
      };
    case actionTypes.FETCH_CURRENT_COMMUNITY_FAILURE:
      return {
        ...state,
        currentCommunity: null,
        communityErrorStatusCode: action.statusCode,
      };
    case actionTypes.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          permissions: action.permissions,
          roles: action.roles,
        },
      };
    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        currentUser: null,
        notifications: [],
        unreadMessagesCount: 0,
        unreadNotificationsCount: 0,
      };
    case communityActionTypes.FOLLOW_COMMUNITY_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          followedCommunities: [
            ...state.currentUser.followedCommunities,
            action.community,
          ],
        },
      };
    case communityActionTypes.UNFOLLOW_COMMUNITY_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          followedCommunities: state.currentUser.followedCommunities
            .filter(g => g.communityId !== action.communityId),
        },
      };
    case editProfileActionTypes.SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profileImageSmall: action.profileImageSmall,
          profileImageMedium: action.profileImageMedium,
        },
      };
    case actionTypes.FETCH_UNREAD_MESSAGES_COUNT_SUCCESS:
      return {
        ...state,
        unreadMessagesCount: action.count,
      };
    case actionTypes.FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS:
      return {
        ...state,
        unreadNotificationsCount: action.count,
      };
    case actionTypes.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
      };
    case wsActionTypes.UPDATE_MESSAGES_COUNT: {
      let unreadMessagesCount = state.unreadMessagesCount;
      switch (action.data.action) {
        case 'inc':
          unreadMessagesCount += action.data.count;
          break;
        case 'dec':
          unreadMessagesCount -= action.data.count;
          break;
        case 'set':
          unreadMessagesCount = action.data.count;
          break;
      }
      return {
        ...state,
        unreadMessagesCount: Math.max(unreadMessagesCount, 0),
      };
    }
    case wsActionTypes.UPDATE_NOTIFICATIONS_COUNT: {
      let unreadNotificationsCount = state.unreadNotificationsCount;
      switch (action.data.action) {
        case 'inc':
          unreadNotificationsCount += action.data.count;
          break;
        case 'dec':
          unreadNotificationsCount -= action.data.count;
          break;
        case 'set':
          unreadNotificationsCount = action.data.count;
          break;
      }
      return {
        ...state,
        unreadNotificationsCount: Math.max(unreadNotificationsCount, 0),
      };
    }
    case actionTypes.RESET_FLOATING_SIGNUP_BOX:
      return {
        ...state,
        isFloatingSignupBoxVisible: true,
      };
    case actionTypes.HIDE_FLOATING_SIGNUP_BOX:
      return {
        ...state,
        isFloatingSignupBoxVisible: false,
      };
    case actionTypes.SET_COMMUNITY_GUIDELINES:
      return {
        ...state,
        currentCommunity: {
          ...state.currentCommunity,
          extendedGuidelinesUrl: action.extendedGuidelinesUrl,
          guidelines: action.guidelines ? action.guidelines.sort((a, b) => a.number - b.number) : null,
        },
      };
    case actionTypes.FETCH_CURRENT_COMMUNITY_ROLES_SUCCESS:
      return {
        ...state,
        currentCommunity: {
          ...state.currentCommunity,
          roles: action.roles,
        },
      };
    case actionTypes.FETCH_FEATURED_POSTS:
      return {
        ...state,
        currentCommunity: {
          ...state.currentCommunity,
          featuredPosts: [],
        },
      };
    case actionTypes.FETCH_FEATURED_POSTS_SUCCESS:
      return {
        ...state,
        currentCommunity: {
          ...state.currentCommunity,
          featuredPosts: action.featuredPosts,
          dismissedFeaturedPostIds: action.dismissedFeaturedPostIds,
        },
      };
    case actionTypes.DISMISS_FEATURED_POST_SUCCESS:
      return {
        ...state,
        currentCommunity: {
          ...state.currentCommunity,
          dismissedFeaturedPostIds: action.dismissedFeaturedPostIds,
        },
      };
  }
  return state;
}
